module.exports = __webpack_public_path__ + "h5/img/bo.e490c4f2.png";